<script setup lang="ts">
import authContent from "~/content/auth.json";

const authStore = useAuthStore();
const route = useRoute();

definePageMeta({
  layout: "static",
});

useSeoMeta({
  title: authContent.login.seo.title,
  description: authContent.login.seo.description,
});

useHead({
  link: [{ rel: "canonical", href: "https://anddine.co.uk/login" }],
});

const { staticUrl } = useImageUrl();

const redirectPath = computed(() => (route.query.redirect as string));
</script>

<template>
  <section class="login">
    <div class="login__left">
      <img
        :src="staticUrl('/Images/site-images/login-new.jpg')"
        alt="login"
        loading="eager"
      />
    </div>
    <div class="login__right">
      <h3 class="pink-text">Login to &amp;Dine</h3>
      <LoginForm :redirect="redirectPath" />
    </div>
  </section>
</template>

<style lang="scss">
.login {
  position: relative;
  width: 100%;
  display: flex;
  height: 100vh;
  overflow: hidden;
  &__left {
    width: 50%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
    }
    @media (max-width: $tablet) {
      display: none;
    }
  }
  &__right {
    padding: 6rem 10% 3rem;
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    overflow-y: auto;
    @media (max-width: $tablet) {
      width: 100%;
      height: auto;
      overflow-y: visible;
      justify-content: flex-start;
      padding: 10rem 10% 0;
    }
  }
}
</style>
